export const API_Account = Object.freeze({
  purchaseInvoice: {
    GET_SUPPLIRE_LIST: "/ChannelSuppliersList",
    ADD_FACTOR_PURCHASE_CUSTOM:
      "/UnitAccounting/FactorBuys/InsertManualFactorBuy",
    GET_LIST_PURCHASE_FACTOR_CUSTOM: "/UnitAccounting/FactorBuys/ListDetailBuy",
    ADD_NAGHDI_FACTOR_PURCHASE:
      "/UnitAccounting/FactorBuys/InsertDocumentToFactorBuy",
    ADD_HAVALE_FACTOR_PURCHASE:
      "/UnitAccounting/FactorBuys/InsertDocumentToFactorBuy",
    ADD_CARTKHAN_FACTOR_PURCHASE:
      "/UnitAccounting/FactorBuys/InsertDocumentToFactorBuy",
    ADD_CHECK_FACTOR_PURCHASE:
      "/UnitAccounting/FactorBuys/InsertDocumentToFactorBuy",
    GET_LIST_PURCHASE: "/UnitAccounting/FactorBuys/ShowListDocumentToFactorBuy",
    FINAL_CONFIRM_PURCHASE_CUSTOM: "/UnitAccounting/FactorBuys/FinalBuyFactor",
    UPDATE_FACTOR_PURCHASE_NAGHDI:
      "/UnitAccounting/FactorBuys/UpdateDocumentToFactorBuy",
    UPDATE_PURCHASE_CHECK:
      "/UnitAccounting/FactorBuys/UpdateDocumentToFactorBuy",
    UPDATE_PURCHASE_CARTKHAN:
      "/UnitAccounting/FactorBuys/UpdateDocumentToFactorBuy",
    UPDATE_PURCHASE_HAVALE:
      "/UnitAccounting/FactorBuys/UpdateDocumentToFactorBuy",
    DELETE_PURCHASE_ITEM:
      "/UnitAccounting/FactorBuys/DeleteDocumentToFactorBuy",
    GET_RESPONSE_CHECK: "/UnitAccounting/FactorBuys/ShowChecksForUpdate",
    ADD_FACTOR_AUTO_PURCHASE:
      "/UnitAccounting/FactorBuys/InsertAutomaticFactorBuy",
    GET_LIST_FACTOR_PURCHASE: "/UnitAccounting/FactorBuys/ShowListFactorBuys",
    DELETE_PURCHACE_PRODUCT: "/UnitAccounting/FactorBuys/DeleteListFactorBuys",
    UPDATE_PURCHASE_PRODUCT: "/UnitAccounting/FactorBuys/UpdateListFactorBuys",
  },
  paymentSell: {
    GET_LIST_PAYMENT_SELL:
      "/UnitAccounting/BasicOperations/ReceiveOperationList",
    GET_LIST_PAYMENT_OPERATION:
      "/UnitAccounting/BasicOperations/PaymentOperationList",
    ADD_CHECK_PAYEMENT_SELL: "/UnitAccounting/BasicOperations/InsertCashChecks",
    UPDATE_CHECK_SELL: "/UnitAccounting/BasicOperations/UpdateCashChecks",
  },
  paymentOperation: {
    ADD_CHECK_PAYMENT_OPERATION: "/UnitAccounting/FactorBuys/PaymentOperation",
    ADD_NAGHDI_PAYMENT_OPERATION: "/UnitAccounting/FactorBuys/PaymentOperation",
    ADD_CARTKHAN_PAYMENT_OPERATION:
      "/UnitAccounting/FactorBuys/PaymentOperation",
    ADD_HAVALE_PAYMENT_OPERATION: "/UnitAccounting/FactorBuys/PaymentOperation",
    GET_LIST_PAYMENT_OPERAITION:
      "/UnitAccounting/FactorBuys/ShowDetailPaymentOperation",
    DELETE_ITEM_PAYMENT_OPERATION:
      "/UnitAccounting/FactorBuys/DeletePaymentOperation",
    UPDATE_NAGHDI_PAYMENT_OPERATION:
      "/UnitAccounting/FactorBuys/UpdatePaymentOperation",
  },
  basicOperations: {
    GET_CASH_DETAIL: "UnitAccounting/BasicOperations/ShowCashDetail",
    GET_BANK_DETAIL: "UnitAccounting/BasicOperations/ShowBankDetail",
    GET_CHECK_DETAIL: "UnitAccounting/BasicOperations/ShowReceiveCheckDetail",
    GET_CHECK_RECEIVED_DETAIL:
      "UnitAccounting/BasicOperations/ShowPaymentCheckDetail",
  },
  recieveOperation: {
    ADD_FACTOR_NAGHDI: "/UnitAccounting/BasicOperations/InsertResiveOperation",
    GET_DETAIL_RECIEVE_OPERATION:
      "/UnitAccounting/BasicOperations/ListDetailResiveOperation",
    ADD_FACTOR_CHECK: "/UnitAccounting/BasicOperations/InsertResiveOperation",
    ADD_FACTOR_HAVALE: "/UnitAccounting/BasicOperations/InsertResiveOperation",
    ADD_FACTOR_CARTKHAN:
      "/UnitAccounting/BasicOperations/InsertResiveOperation",
    DELETE_FACTOR_ITEM: "/UnitAccounting/BasicOperations/DeleteResiveOperation",
    UPDATE_RECIEVE_OPERATION:
      "/UnitAccounting/BasicOperations/UpdateResiveOperation",
  },
  haveleHesab: {
    GET_LIST_HAVALE_HESAB:
      "/UnitAccounting/BasicOperations/AccountToAccountTransfersList",
    GET_ACCESS_HAVALE_HESAB_STATUS:
      "/UnitAccounting/BasicOperations/AccountToAccountTransfersStatuses",
    ADD_HAVALE_HESAB:
      "/UnitAccounting/BasicOperations/InsertAccountToAccountTransfers",
  },
  payment: {
    NON_PORTAL_PAYMENT: "/UnitAccounting/UpdateChangeStatusAdminOrderstookpay",
  },
  sms: {
    GET_LIST_SMS_PANNEL: "/UnitManagement/Management/SmsPanel/SmsPanelsList",
    ACTIVE_SMS_PANNEL: "/UnitManagement/Management/SmsPanel/activatedPanel",
    DETAIL_SMS_PANNEL: "/UnitManagement/Management/SmsPanel/SmsPanelDetail",
    UPDATE_SMS_PANNEL:
      "/UnitManagement/Management/SmsPanel/updateSmsPanelOption",
  },
});
